module.exports = "<app-iframe [operationID]=\"operationID\"></app-iframe>"